// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_parking_parkinglines_surface: MapboxStyleLayer[] = [
  {
    id: 'street parking lines copy 1',
    type: 'line',
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'surface'], ['ground', 'grass_paver', 'compacted'], true, false],
        'hsl(142, 94%, 40%)',
        ['match', ['get', 'surface'], ['concrete', 'concrete:plates', 'asphalt'], true, false],
        'hsl(344, 93%, 35%)',
        ['match', ['get', 'surface'], ['cobblestone', 'sett', 'paving_stones'], true, false],
        'hsl(164, 92%, 42%)',
        ['has', 'surface'],
        'hsl(280, 94%, 63%)',
        'hsl(280, 67%, 26%)',
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
      'line-opacity': ['match', ['get', 'operator_type'], ['private'], 0.33, 1],
    },
    filter: ['has', 'capacity'],
  },
  {
    id: 'parallel pattern copy',
    type: 'line',
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 0.7, 20, 5],
      'line-dasharray': [4, 2],
      'line-opacity': 0.67,
    },
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['parallel'], true, false],
      ['has', 'capacity'],
    ],
  },
  {
    minzoom: 16,
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['diagonal'], true, false],
      ['has', 'capacity'],
    ],
    type: 'line',
    id: 'diagonal pattern copy',
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
      'line-opacity': 0.67,
      'line-pattern': 'parking_diagonal',
    },
  },
  {
    minzoom: 16,
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['perpendicular'], true, false],
      ['has', 'capacity'],
    ],
    type: 'line',
    id: 'perpendicular pattern copy',
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-pattern': 'parking_perpendicular',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
      'line-opacity': 0.67,
    },
  },
  {
    minzoom: 15,
    layout: {
      'symbol-placement': 'line-center',
      'text-field': ['to-string', ['get', 'surface']],
      'text-allow-overlap': true,
      'text-ignore-placement': true,
      'text-offset': [0, 0.8],
      'text-size': ['interpolate', ['linear'], ['zoom'], 15, 9, 18, 16],
    },
    filter: ['has', 'capacity'],
    type: 'symbol',
    id: 'surface label-line',
    paint: {
      'text-color': 'rgb(60, 60, 60)',
      'text-halo-color': 'rgb(255, 255, 255)',
      'text-halo-width': ['interpolate', ['linear'], ['zoom'], 15, 1, 18, 2.5],
      'text-opacity': ['interpolate', ['linear'], ['zoom'], 17, 0, 18, 1],
    },
  },
]
